module.exports = __webpack_public_path__ + "static/img/materials2.7935d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials2.png
// module id = ZWan
// module chunks = 2